<div class="error-section-wrapper">
  <mat-drawer-container #matDrawerContainer (backdropClick)="closeBackdrop()">
      <mat-drawer role="navigation" class="left-sidenav-drawer" #leftnav [opened]="leftSideNav">
        <uni-left-sidenav-collapsed (toggle)="closeBackdrop()" [showSidenav]="true" [showDiscoverSection]="true">
        </uni-left-sidenav-collapsed>
      </mat-drawer>

      <mat-drawer-content>
          <div class="fixed top-0" fxLayout="row" *ngIf="!mobileView">
              <uni-left-sidenav-collapsed [showSidenav]="false">
              </uni-left-sidenav-collapsed>
          </div>
      </mat-drawer-content>
  </mat-drawer-container>
</div>
<div class="error-section">
  <uni-error
    [errorObj]="error">
  </uni-error>
</div>
